import "regenerator-runtime/runtime";
import "lib/polyfills";
import "styles/tailwind.css";
import "lib/monkeyPatching";

import React from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter as Router } from "react-router-dom";

import WalletProvider from "lib/wallets/WalletProvider";

import App from "./App/App";
import reportWebVitals from "./reportWebVitals";
import { ApolloProvider } from "@apollo/client";
import { client2 } from "domain/synthetics/leaderboard";
import { BsChatFill, BsTelegram } from "react-icons/bs";

createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <Router>
      <WalletProvider>
        <ApolloProvider client={client2}>
          <App />
          <div onClick={()=>{
            window.open('https://t.me/perpx_dex', '_blank');
          }} id="chat-icon" style={{
    position: 'fixed',
    bottom: 24,
    right: 24,
    padding:5,
    borderRadius: 49,
    zIndex: 1000,
    backgroundColor: 'white',
    boxShadow: '0 2px 10px rgba(0, 0, 0, 0.1)',
    display: 'flex',
    cursor: 'pointer',
  }}>
      <BsTelegram color="#33b6bd" style={{width:40,height:40}} />
    </div>
        </ApolloProvider>
      </WalletProvider>
    </Router>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.info))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
export { formatTokenAmount, formatTokenAmountWithUsd, formatUsd } from "./lib/numbers";
